import type { CSSProperties, ReactNode } from "react";
import { CreferencePillLeading } from "./CreferencePillLeading";
import { getCreferencePillInlineClusterStyle } from "./creferencePillContentModel";
/** Baked Flow tight: the cluster carries the icon seal alone — the whole
 *  label flows outside it as inline text (CreferencePillContent). */
export interface CreferencePillInlineClusterProps {
    isHovered: boolean;
    isMemberReference: boolean;
    isUnresolved: boolean;
    leading: ReactNode;
    memberColor: string | null;
    memberProviderIconPath: string;
    memberProviderSlug: string;
}
export function CreferencePillInlineCluster({ isHovered, isMemberReference, leading, memberColor, memberProviderIconPath, memberProviderSlug, }: CreferencePillInlineClusterProps): ReactNode {
    return (
	    <span style={getCreferencePillInlineClusterStyle()}>
	      <CreferencePillLeading isHovered={isHovered} isMemberReference={isMemberReference} leading={leading} memberColor={memberColor} memberProviderIconPath={memberProviderIconPath} memberProviderSlug={memberProviderSlug}/>
	    </span>
    );
}
